import { EVENTS_PREFIX } from "core/config";
import { NULL } from "constants/primitives";
import dispatchJSEvent from "helpers/dispatchJSEvent";

export const EVENT_NAME = `${EVENTS_PREFIX}_tcf_consent_updated`;

const dispatchTCFConsentUpdated = () => {
  const jsEventData = NULL
  dispatchJSEvent(EVENT_NAME, jsEventData);
};

export default dispatchTCFConsentUpdated;
